import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { services } from '../lib/mock';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { ArrowRight } from 'lucide-react';

export default function Services() {
  return (
    <div className="pt-20">
      <SEO 
        title="Water Treatment Services - STP, ETP, WTP & RO Plant"
        description="End-to-end water treatment services in Ludhiana: Sewage Treatment Plant (STP), Effluent Treatment Plant (ETP), Water Treatment Plant (WTP), RO systems, solid waste management & air pollution control."
        keywords="water treatment services, STP service, ETP plant maintenance, WTP installation, RO plant service, air pollution control Ludhiana, industrial water treatment company"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://bgtechnochem.com/" },
            { "@type": "ListItem", "position": 2, "name": "Services", "item": "https://bgtechnochem.com/services" }
          ]
        }}
      />
      
      <section className="bg-slate-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-4xl font-bold mb-6">Our Engineering Solutions</h1>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto">
            End-to-end water and wastewater treatment services designed for performance, compliance, and sustainability.
          </p>
        </div>
      </section>

      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
          
          {services.map((service, index) => {
            const isEven = index % 2 === 0;
            return (
              <div key={service.id} className={`flex flex-col lg:flex-row gap-12 items-center ${!isEven ? 'lg:flex-row-reverse' : ''}`}>
                
                {/* Image Side */}
                <div className="w-full lg:w-1/2">
                  <div className="relative group overflow-hidden rounded-2xl shadow-2xl">
                    <div className="absolute inset-0 bg-primary/20 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                    <img 
                      src={service.image} 
                      alt={service.title} 
                      className="w-full h-[400px] object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                </div>

                {/* Content Side */}
                <div className="w-full lg:w-1/2 space-y-6">
                  <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-xl mb-4">
                    <service.icon className="w-8 h-8 text-primary" />
                  </div>
                  <h2 className="text-3xl font-bold text-slate-900">{service.title}</h2>
                  <p className="text-lg text-slate-600 leading-relaxed">
                    {service.longDesc}
                  </p>
                  
                  <div className="pt-4">
                    <h4 className="font-semibold text-slate-900 mb-3">Key Benefits:</h4>
                    <ul className="space-y-2">
                      {[
                        "Custom Design & Engineering",
                        "Pollution Board Compliant",
                        "Low Operational Cost",
                        "High Efficiency"
                      ].map((benefit, idx) => (
                        <li key={idx} className="flex items-center text-slate-600">
                          <div className="w-2 h-2 bg-emerald-500 rounded-full mr-3"></div>
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="pt-6">
                    <Link to="/contact">
                      <Button className="bg-primary hover:bg-brand-darkBlue">
                        Request Consultation <ArrowRight className="ml-2 w-4 h-4" />
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}

        </div>
      </section>

      {/* Chemical Supply Section */}
      <section className="py-20 bg-emerald-900 text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">Need Industrial Chemicals?</h2>
          <p className="text-lg text-emerald-100 mb-8 max-w-2xl mx-auto">
            We supply high-grade consumables for all types of water treatment plants. Ensure your plant runs at peak efficiency.
          </p>
          <Link to="/contact">
            <Button size="lg" variant="secondary" className="bg-white text-emerald-900 hover:bg-emerald-50 font-bold">
              Order Chemicals
            </Button>
          </Link>
        </div>
      </section>

    </div>
  );
}
